module.exports = __webpack_public_path__ + "static/media/mastercard.805e608b.svg";